import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  add,
} from '../redux/blockers'

const fetchBlockers = () => async dispatch => {  
  dispatch(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  try {
    const { Blockers } = await apiGetData('Blockers')

    dispatch([
      ...Blockers.map(Blocker => add({
        id: Blocker.Id,
        type: Blocker.Type,
        name: Blocker.Name,
        description: Blocker.Description && JSON.parse(Blocker.Description),
        position: Blocker.Position,
      })),
      setLoadStatus({
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    dispatch(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))
  }
}

export default fetchBlockers
